import { createActions } from 'redux-actions';

export const {
  pricing: { getPricing, receivePricing, getPricingFailure },
}: any = createActions({
  PRICING: {
    GET_PRICING: () => ({
      isFetchingPricing: true,
    }),
    RECEIVE_PRICING: (pricing) => ({
      isFetchingPricing: false,
      pricing,
      isPricingError: false,
    }),
    GET_PRICING_FAILURE: () => ({
      isFetchingPricing: false,
      pricing: {},
      isPricingError: true,
    }),
  },
});
